import React, { useEffect, useState } from 'react';
import { Typography, Container } from 'antd';
import { getCurrentDestination } from '../services/destinationsService';

function Analytics() {
  const [city, setCity] = useState();

  useEffect(() => {
    getCurrentDestination().then(destination => {
      setCity(destination);
      console.log('Current destination:', destination ? destination.dashboard_url : 'Unknown');
    });
  }, []);

  return (
    <div>
      <Typography.Title level={2}>Analytics</Typography.Title>
      {city && city.dashboard_url ? (
        <iframe
          title="Analytics"
          src={city.dashboard_url}
          width="100%"
          height="800"
          frameBorder="0"
        ></iframe>
      ) : (
        <Typography.Paragraph>View analytics and insights not setup;</Typography.Paragraph>
      )}
    </div>
  );
}

export default Analytics;
